export default __webpack_public_path__ + "static/media/details-reversed.d9a0d1ea.svg";